<template>
  <div>
    <Modal
      v-model="modal1"
      :title="title"
      :loading="loading"
      :width="width"
      @on-ok="uploadImg"
      @on-cancel="close"
    >
      <slot>
        <div
          style="display: flex;justify-content: space-around;align-items: center;"
        >
        <!-- 原图 -->
          <div class="cropper" :style="originStyle">
            <img ref="cropperImg" alt="" />
          </div>
          <!-- 向右箭头 -->
          <div style="text-align: center;margin: 15px 0;">
            <Icon size="30" type="md-arrow-forward" />
          </div>
          <!-- 预览 -->
          <div class="preview-area">
            <div
              :class="options.preview.slice(1)"
              :style="previewStyle"
            ></div>
          </div>
        </div>
      </slot>
    </Modal>
  </div>
</template>

<script>
import ajaxRequest from '@/api/ajax'
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  name: "CropperImg",
  props: {
    width:{
      type: Number,
      default: 500
    },
    file: {  //上传的文件
      type: Object,
      default: ()=>({})
    },
    title: { //modal的标题
      type: String,
      default: ""
    },
    uploadUrl: { //上传地址
      type: String,
      default: ""
    },
    originStyle:{
      type: Object,
      default: ()=>({position: 'relative'})
    },
    previewStyle: { //预览图片的样式
      type: Object,
      default: () => ({ height: "200px" })
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      modal1: false,
      cropper: null,
      // aspectRatio: 1920 / 1080,
      compressImageSize:"",
      img: "",
      loading: false,
      cropImg: "",
      cropWidth: "",
      cropHeight: ""
    };
  },
  mounted() {
    this.cropper = new Cropper(this.$refs.cropperImg, {
      ...this.$listeners,
      ...this.options
    });
  },
  methods: {
    open() {
      this.modal1 = true;
    },
    close() {
      this.modal1 = false;
    },
    //将base64转换为blob, 压缩处理
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    crop(e) {
      this.cropWidth = parseInt(e.detail.width);
      this.cropHeight = parseInt(e.detail.height);
    },
    // 参数为可上传的最大图片大小, 单位是 kb
    compressImage(targetSize = 0) {
      const base64 = this.cropper
        .getCroppedCanvas({
          width: this.cropWidth,
          height: this.cropHeight,
          fillColor: "#fff",
          imageSmoothingEnabled: true,
          imageSmoothingQuality: "high"
        })
        .toDataURL(this.file.type, 0.7);
      // console.log(base64, "base64");
      const blob = this.dataURLtoBlob(base64);

      this.compressImageSize = parseInt(blob.size / 1024);
      if (this.compressImageSize > targetSize) {
        return false;
      } else {
        return blob;
      }
    },
    uploadImg() {
      let that = this;
      // console.log(this.cropWidth, this.cropHeight);
      const result = this.compressImage(500);
      // console.log(result);
      // return;
      if (result) {
        var file = new File([result], `file.${result.type.slice(6)}`, {
          type: result.type,
          lastModified: Date.now()
        });

        // that.$refs.upload.clearFiles();
        let formData = new FormData();
        formData.append("file", file);
        ajaxRequest
          .post(this.uploadUrl, formData, {
            Token: $cookies.get("kls_user_session")
          })
          .then(res => {
            // console.log(res);
            if (res.err_code === 0) {
              this.$emit("onUploadSuccess", res.body);
            }
          });
      } else {
        this.$util.showError("the uploaded image cannot exceed 500kb");
      }
    }
  }
};
</script>

<style scoped lang="less">
.cropper {
  width: 488px;
  height: 200px;
}
.preview-area {
  // width: 340px;
}
.preview-area p {
  font-size: 1.25rem;
  margin: 0;
  margin-bottom: 1rem;
}
.preview-area p:last-of-type {
  margin-top: 1rem;
}
.previewImg {
  width: 300px;
  // height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/cropper_img.vue